// extracted by mini-css-extract-plugin
export default {"table-container":"trGkbhgrANhnMVTeT0ml","table-top-right-field":"fKclGGpEyPsOs4gElpoC","divider":"CkUK5GCHXooD5dqAZNDv","table-wrapper":"rV0cDpRbJ0FJFbhO4UUn"};